import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { ReactComponent as CheckBoxCheckedIcon } from "../../../assets/svg/checkbox_checked.svg";
import { ReactComponent as CheckBoxIcon } from "../../../assets/svg/checkbox.svg";
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles((theme) => ({
  formControl: {
    // margin: theme.spacing(1),
    marginLeft: 0,
    minWidth: 200,
    padding: 0,
    maxWidth: 200,
    backgroundColor: "#fff",
    "& .MuiInputBase-root": {
      borderRadius: 0
    }
    // border: "1px solid",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: {
    padding: 8,
    fontSize: "0.8rem",
    fontFamily: "OpenSans",
  },
  paperRoot: {
    transformOrigin: "none !important"
  }
}));


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;


export default function MultipleSelect(props) {
  const { labelKey, items, onChange, defaultValue, defaultSelect = true, placeholder } = props;
  const classes = useStyles();
  const [selected, setSelected] = React.useState([]);
  const anchorRef = React.useRef(null);
  const MenuProps = {
    autoFocus: false,
    disableAutoFocusItem: false,
    classes: { paper: classes.paperRoot },
    getContentAnchorEl: function (e) { },
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        // width: 250,
      },
    },
  };

  const handleChange = (event) => {
    setSelected(event.target.value);
    let selectedItems = items.filter(item => event.target.value.indexOf(item[labelKey]) !== -1)
    onChange(selectedItems);
  };
  React.useEffect(() => {
    if (defaultValue && defaultValue.length > 0) {
      setSelected(defaultValue.map(el => el[labelKey]))
    } else if (defaultSelect) {
      if (items[0] && labelKey !== "networkDisplayName") {
        setSelected([items[0][labelKey]])
        onChange([items[0]]);
      }
      if (items[0] && items[1] && labelKey === "networkDisplayName") {
        setSelected([items[0][labelKey], items[1][labelKey]])
        onChange(items);
      }
    }

  }, [items, labelKey, defaultValue])

  return (
    <div>

      <FormControl className={classes.formControl} variant="outlined">
        {selected.length === 0 && placeholder && <div style={{ position: "absolute", margin: 8, fontSize: "0.8rem", fontFamily: "OpenSans", color: "#a0a0a0" }}>{placeholder}</div>}
        <Select
          labelId="label"
          id="demo-simple-select"
          multiple
          value={selected}
          onChange={handleChange}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
          defaultValue={items[0] ? items[0][labelKey] : ""}
          classes={{ outlined: classes.select }}
          IconComponent={KeyboardArrowDownIcon}
          inputProps={{ placeholder: "sdsds" }}
        >

          {items.map((item) => (
            <MenuItem key={item[labelKey]} value={item[labelKey]}>
              <Checkbox
                checkedIcon={<CheckBoxCheckedIcon width={20} height={20} />}
                // icon={<CheckBoxIcon width={20} height={20} />}
                checked={selected.indexOf(item[labelKey]) > -1} color="primary" />
              <ListItemText primary={item[labelKey]} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div >
  );
}
